import { render, staticRenderFns } from "./MassEditBotSettings.vue?vue&type=template&id=2b83dea4&scoped=true"
import script from "./MassEditBotSettings.vue?vue&type=script&lang=ts"
export * from "./MassEditBotSettings.vue?vue&type=script&lang=ts"
import style0 from "./MassEditBotSettings.vue?vue&type=style&index=0&id=2b83dea4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83dea4",
  null
  
)

export default component.exports